<template>
  <div class="container-fluid mt-4">
    <div class="card-header card-custom-brown" slot="card_title">
      <i class="fas fa-cubes"></i> Gestion des cotations
    </div>
    <form @keydown="form.onKeydown($event)">
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="box box-primary">
            <div
              class="box-header with-border d-flex justify-content-between mt-3"
            >
              <h3 class="box-title">
                <i class="fa fa-eye"></i> Aperçu d'une cotation
              </h3>

              <router-link
                :to="{ name: 'cotations' }"
                class="col-12 mb-1 mb-sm-0 col-sm-auto btn btn-danger mr-sm-2"
              >
                Mes cotations
              </router-link>
            </div>

            <div class="box-body">
              <div class="row d-flex justify-content-center">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="client"
                      >Client <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      :value="form.client_nom"
                      id="client"
                      name="client"
                      placeholder="Client"
                      disabled
                    />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <label for="date"
                      >Date <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      :class="{ 'is-invalid': form.errors.has('date') }"
                      v-model="form.date"
                      id="date"
                      name="date"
                      v-input-mask
                      data-inputmask-alias="datetime"
                      data-inputmask-inputformat="dd/mm/yyyy"
                      placeholder="Date"
                      disabled
                    />
                    <has-error :form="form" field="date"></has-error>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label for="reference"
                      >Référence <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('reference'),
                      }"
                      v-model="form.reference"
                      id="reference"
                      name="reference"
                      placeholder="Référence"
                      maxlength="100"
                      disabled
                    />
                    <has-error :form="form" field="reference"></has-error>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p
        v-if="form.brouillon"
        class="text-danger h6 font-italic text-center my-2"
      >
        Votre cotation n'est pas encore envoyée
      </p>

      <div class="row" v-if="form.client">
        <div class="col-md-12">
          <div
            id="alert"
            v-if="errorTableau === true"
            class="alert alert-danger alert-dismissible"
            style="vertical-align: middle"
          >
            <button
              type="button"
              class="close alert-close"
              id="alert-close"
              @click="errorTableau = !errorTableau"
            >
              &times;
            </button>
            <p v-text="errorTableauMessage"></p>
          </div>

          <div class="box box-primary">
            <div class="box-body table-responsive">
              <table
                id="line-table"
                class="line-table table table-condensed table-striped table-bordered table-hover w-100"
              >
                <thead class="label-info text-white">
                  <tr v-if="Number(user.prix) === 0 && Number(assujjeti) === 0">
                    <th class="col-sm-10" style="font-weight: bold">Article</th>
                    <th class="col-sm-2" style="font-weight: bold">Quantité</th>
                  </tr>
                  <tr
                    v-else-if="
                      Number(user.prix) === 0 && Number(assujjeti) === 1
                    "
                  >
                    <th class="col-sm-8" style="font-weight: bold">Article</th>
                    <th class="col-sm-2" style="font-weight: bold">Quantité</th>
                    <th class="col-sm-2" style="font-weight: bold">TVA %</th>
                  </tr>
                  <tr
                    v-else-if="
                      Number(user.prix) === 1 && Number(assujjeti) === 0
                    "
                  >
                    <th class="col-sm-7" style="font-weight: bold">Article</th>
                    <th class="col-sm-1" style="font-weight: bold">Quantité</th>
                    <th class="col-sm-2" style="font-weight: bold">
                      Prix U HT
                    </th>
                    <th class="col-sm-2" style="font-weight: bold">Montant</th>
                  </tr>
                  <tr
                    v-else-if="
                      Number(user.prix) === 1 && Number(assujjeti) === 1
                    "
                  >
                    <th class="col-sm-6" style="font-weight: bold">Article</th>
                    <th class="col-sm-1" style="font-weight: bold">Quantité</th>
                    <th class="col-sm-2" style="font-weight: bold">
                      Prix U HT
                    </th>
                    <th class="col-sm-1" style="font-weight: bold">TVA %</th>
                    <th class="col-sm-2" style="font-weight: bold">Montant</th>
                  </tr>
                </thead>
                <tbody
                  v-if="Number(user.prix) === 0 && Number(assujjeti) === 0"
                >
                  <tr v-for="(item, key) in form.itemList" v-bind:key="key">
                    <td style="vertical-align: middle">
                      {{
                        JSON.parse(item.article_libelle)[locale]
                          ? JSON.parse(item.article_libelle)[locale]
                          : "###"
                      }}
                    </td>
                    <td style="vertical-align: middle">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.quantite"
                        placeholder="Quantité"
                        @focus="$event.target.select()"
                        disabled
                      />
                    </td>
                  </tr>
                </tbody>
                <tbody
                  v-else-if="Number(user.prix) === 0 && Number(assujjeti) === 1"
                >
                  <tr v-for="(item, key) in form.itemList" v-bind:key="key">
                    <td style="vertical-align: middle">
                      {{
                        JSON.parse(item.article_libelle)[locale]
                          ? JSON.parse(item.article_libelle)[locale]
                          : "###"
                      }}
                    </td>
                    <td style="vertical-align: middle">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.quantite"
                        placeholder="Quantité"
                        @focus="$event.target.select()"
                        disabled
                      />
                    </td>

                    <td style="vertical-align: middle">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.tva"
                        placeholder="TVA"
                        @focus="$event.target.select()"
                        disabled
                      />
                    </td>
                  </tr>
                </tbody>
                <tbody
                  v-else-if="Number(user.prix) === 1 && Number(assujjeti) === 0"
                >
                  <tr v-for="(item, key) in form.itemList" v-bind:key="key">
                    <td style="vertical-align: middle">
                      {{
                        JSON.parse(item.article_libelle)[locale]
                          ? JSON.parse(item.article_libelle)[locale]
                          : "###"
                      }}
                    </td>
                    <td style="vertical-align: middle">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.quantite"
                        placeholder="Quantité"
                        @focus="$event.target.select()"
                        disabled
                      />
                    </td>
                    <td style="vertical-align: middle">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.prix"
                        placeholder="Prix U HT"
                        @focus="$event.target.select()"
                        disabled
                      />
                    </td>

                    <td style="vertical-align: middle" class="text-right">
                      <b>{{
                        (item.prix * item.quantite +
                          (item.prix * item.quantite * item.tva) / 100)
                          | currency
                      }}</b>
                    </td>
                  </tr>
                </tbody>
                <tbody
                  v-else-if="Number(user.prix) === 1 && Number(assujjeti) === 1"
                >
                  <tr v-for="(item, key) in form.itemList" v-bind:key="key">
                    <td style="vertical-align: middle">
                      {{
                        JSON.parse(item.article_libelle)[locale]
                          ? JSON.parse(item.article_libelle)[locale]
                          : "###"
                      }}
                    </td>
                    <td style="vertical-align: middle">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.quantite"
                        placeholder="Quantité"
                        @focus="$event.target.select()"
                        disabled
                      />
                    </td>
                    <td style="vertical-align: middle">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.prix"
                        placeholder="Prix U HT"
                        @focus="$event.target.select()"
                        disabled
                      />
                    </td>

                    <td style="vertical-align: middle">
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="item.tva"
                        placeholder="TVA"
                        @focus="$event.target.select()"
                        disabled
                      />
                    </td>

                    <td style="vertical-align: middle" class="text-right">
                      <b>{{
                        (item.prix * item.quantite +
                          (item.prix * item.quantite * item.tva) / 100)
                          | currency
                      }}</b>
                    </td>
                  </tr>
                </tbody>
                <tfoot v-if="form.itemList.length > 0" class="footerTotal">
                  <tr v-if="Number(user.prix) === 0 && Number(assujjeti) === 0">
                    <td colspan="3" style="text-align: right">
                      {{ form.itemList.length + " Article(s)" }}
                    </td>
                  </tr>
                  <tr
                    v-else-if="
                      Number(user.prix) === 0 && Number(assujjeti) === 1
                    "
                  >
                    <td colspan="4" style="text-align: right">
                      {{ form.itemList.length + " Article(s)" }}
                    </td>
                  </tr>
                  <tr
                    v-else-if="
                      Number(user.prix) === 1 && Number(assujjeti) === 0
                    "
                  >
                    <td colspan="1" style="text-align: right">TOTAL</td>
                    <td colspan="4" class="text-right">
                      {{ total | currency }}
                    </td>
                  </tr>
                  <tr
                    v-else-if="
                      Number(user.prix) === 1 && Number(assujjeti) === 1
                    "
                  >
                    <td colspan="1" style="text-align: right">TOTAL</td>
                    <td colspan="5" class="text-right">
                      {{ total | currency }}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-right">
          <ButtonLoader
            v-show="form.brouillon"
            :busy="form.busy"
            @btn-click="send"
            classes="btn-send"
            loadText="Traitement en cours..."
            Text="Envoyer"
          ></ButtonLoader>

          <router-link
            :to="{
              name: 'cotation-edit',
              params: { id: id },
            }"
            class="col-12 mb-1 mb-sm-0 col-sm-auto btn btn-primary mr-sm-2"
            v-if="hasDevis <= 0"
          >
            Modifier
          </router-link>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import * as services from "./service/services";
import Form from "vform";

export default {
  name: "CotationShow",
  data: function () {
    return {
      form: new Form({
        client: "",
        date: "",
        reference: "",
        brouillon: false,
        itemList: [],
      }),

      id: 0,
      hasDevis: 0,

      errorTableau: false,
      errorTableauMessage: "",

      title: "Cotation - Aperçu",
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + " | %s",
    };
  },
  methods: {
    async send() {
      this.errorTableau = false;
      this.errorTableauMessage = "";
      this.form.brouillon = false;

      await this.form
        .put(services.UPDATE + "/" + this.id)
        .then((data) => {
          this.$swal({
            position: "top-end",
            icon: data.data.type,
            text: data.data.message,
            showConfirmButton: false,
            timer: window.Timer,
          });
        })
        .catch((err) => {
          let self = this;
          $.each(err.response.data.errors, function (key, value) {
            if (key.includes("itemList")) {
              self.errorTableau = true;
              self.errorTableauMessage = value[0];
              return false;
            }
          });
        });
    },
  },
  computed: {
    total: function () {
      return _.sum(
        this.form.itemList.map(
          (item) =>
            item.quantite * item.prix +
            (item.quantite * item.prix * item.tva) / 100
        )
      );
    },
    locale() {
      return this.$store.getters["configapp/locale"];
    },
    assujjeti: function () {
      return this.$store.getters["auth/userp"].assujetti_tva;
    },
    user() {
      return this.$store.getters["auth/userp"];
    },
  },

  mounted: function () {
    let self = this;
    self.id = self.$route.params.id;
    axios
      .all([
        axios.get(services.REQUIREMENTS),
        axios.get(services.GET + "/" + self.id),
      ])
      .then(
        axios.spread(function (resp1, resp2) {
          self.form.client_nom = resp2.data.cotation.client;
          self.form.client = resp2.data.cotation.client_uuid;
          self.form.date = self.convertDate(
            resp2.data.cotation.date,
            null,
            true,
            false
          );
          self.form.reference = resp2.data.cotation.reference;
          self.form.brouillon = resp2.data.cotation.brouillon;
          self.hasDevis = resp2.data.cotation.hasDevis;

          $.each(resp2.data.itemLists, function (key, item) {
            let line = {
              id: item.id,
              article: item.uuid,
              article_libelle: item.designation,
              unite: item.unite_uuid,
              unite_libelle: item.unite,
              prix: item.prix,
              tva: item.tva,
              quantite: item.quantite,
            };

            self.form.itemList.push(line);
          });
        })
      )
      .catch();
  },
};
</script>

<style scoped>
.btn-send {
  padding: 0.5rem 1rem;
  background-color: #caaa73;
  border-radius: 5px;
  font-weight: bold;
  margin: 0 0.5rem;
}

.btn-send:hover {
  background-color: #b19058;
}
</style>
